var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value!=null)?_c('span',[_vm._v(_vm._s(Number(_vm.value).toLocaleString())+" "+_vm._s(_vm.unit))]):_c('span',[_vm._v(" --- "+_vm._s(_vm.unit))])}
var staticRenderFns = []

export { render, staticRenderFns }